import { ArrowRightIcon, CheckCircleIcon, FileTextIcon } from "@phosphor-icons/react";
import { Button } from "@reactive-resume/ui";

type Props = {
  source: "document" | "linkedin";
  onOpenBuilder: () => void;
  onOpenDocuments: () => void;
};

export const ImportSuccessStep = ({ source, onOpenBuilder, onOpenDocuments }: Props) => {
  const fromLinkedIn = source === "linkedin";

  return (
    <section className="mx-auto grid min-h-[55dvh] w-full max-w-xl place-items-center py-8 text-center">
      <div>
        <span className="mx-auto grid size-16 place-items-center rounded-full bg-emerald-50 text-emerald-500">
          <CheckCircleIcon aria-hidden size={34} weight="fill" />
        </span>

        <p className="mt-5 text-[10px] font-bold uppercase tracking-[0.14em] text-emerald-600">
          Import terminé
        </p>

        <h1 className="mt-1 text-2xl font-bold tracking-tight text-[#071451] sm:text-3xl">
          Votre CV est prêt
        </h1>

        <p className="mx-auto mt-3 max-w-md text-xs leading-5 text-slate-600 sm:text-sm">
          {fromLinkedIn
            ? "Vos informations LinkedIn ont été ajoutées à un nouveau CV."
            : "Les informations de votre document ont été ajoutées à un nouveau CV."}
        </p>

        <div className="mt-6 rounded-2xl border border-indigo-100 bg-indigo-50/50 p-4 text-left">
          <div className="flex items-start gap-3">
            <span className="grid size-9 shrink-0 place-items-center rounded-xl bg-white text-indigo-600">
              <FileTextIcon aria-hidden size={18} />
            </span>

            <div>
              <h2 className="text-xs font-bold text-[#071451]">Dernière vérification</h2>

              <p className="mt-1 text-[10px] leading-4 text-slate-600 sm:text-xs">
                Ouvrez le CV dans le builder pour compléter les informations manquantes et vérifier
                les dates, les textes et la mise en page.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-6 flex flex-col gap-2 sm:flex-row">
          <Button
            type="button"
            variant="outline"
            onClick={onOpenDocuments}
            className="min-h-11 flex-1 rounded-xl"
          >
            Voir mes CV
          </Button>

          <Button
            type="button"
            onClick={onOpenBuilder}
            className="min-h-11 flex-1 rounded-xl bg-gradient-to-r from-indigo-700 via-blue-600 to-emerald-500 font-bold text-white"
          >
            Ouvrir dans le builder
            <ArrowRightIcon aria-hidden size={16} weight="bold" />
          </Button>
        </div>
      </div>
    </section>
  );
};
